"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approverReviewFrontendSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.approverReviewFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'approvalDecisionCode',
        'approverLevelIndicator',
        'approverName',
        'approverTitleTypeCode',
        'approverUserID',
    ],
    properties: {
        approvalDecisionCode: {
            type: 'number',
            enum: Object.values(constants_1.ApprovalDecisionCode),
        },
        approverLevelIndicator: {
            type: 'number',
            enum: Object.values(constants_1.ApprovalLevelIndicator),
        },
        approverName: {
            type: 'string',
            minLength: 1,
            maxLength: 41,
            errorMessage: 'Should have maximum of 41 characters',
        },
        approverTitleTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.TitleTypeCode),
            errorMessage: 'Should equate to a valid TitleTypeCode enum value',
        },
        approverUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUIDv4 format',
        },
        decisionComment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should have maximum of 1000 characters',
        },
        decisionTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        documentIDs: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                format: 'uuid',
            },
            errorMessage: 'Should be an array of UUIDv4s or null',
        },
    },
};
